"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Prize_exports = {};
__export(Prize_exports, {
  default: () => Prize_default
});
module.exports = __toCommonJS(Prize_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.9766 17.2031C14.1719 17.2031 14.3346 17.2682 14.4648 17.3984C14.5951 17.5286 14.6602 17.6914 14.6602 17.8867C14.6602 18.082 14.5951 18.2513 14.4648 18.3945C14.3346 18.5247 14.1719 18.5898 13.9766 18.5898H7.02344C6.82812 18.5898 6.66536 18.5247 6.53516 18.3945C6.40495 18.2513 6.33984 18.082 6.33984 17.8867C6.33984 17.6914 6.40495 17.5286 6.53516 17.3984C6.66536 17.2682 6.82812 17.2031 7.02344 17.2031H13.9766ZM16.75 1.91016C17.3229 1.91016 17.8112 2.11849 18.2148 2.53516C18.6315 2.9388 18.8398 3.42708 18.8398 4V8.16016C18.8398 9.11068 18.5013 9.92448 17.8242 10.6016C17.1602 11.2786 16.3529 11.6237 15.4023 11.6367C15.1029 12.2227 14.7057 12.737 14.2109 13.1797C13.7292 13.6224 13.1888 13.9674 12.5898 14.2148V15.7969H8.41016V14.2148C7.8112 13.9674 7.26432 13.6224 6.76953 13.1797C6.28776 12.737 5.89714 12.2227 5.59766 11.6367C4.64714 11.6237 3.83333 11.2786 3.15625 10.6016C2.49219 9.92448 2.16016 9.11068 2.16016 8.16016V4C2.16016 3.42708 2.36198 2.9388 2.76562 2.53516C3.18229 2.11849 3.67708 1.91016 4.25 1.91016H16.75ZM3.54688 8.16016C3.5599 8.62891 3.70312 9.05208 3.97656 9.42969C4.26302 9.79427 4.6276 10.0352 5.07031 10.1523C5.03125 9.98307 4.9987 9.80729 4.97266 9.625C4.95964 9.42969 4.95312 9.24089 4.95312 9.05859V3.29688H4.25C4.05469 3.29688 3.88542 3.36849 3.74219 3.51172C3.61198 3.64193 3.54688 3.80469 3.54688 4V8.16016ZM12.9609 7.00781C13.013 6.95573 13.0456 6.89714 13.0586 6.83203C13.0846 6.75391 13.0911 6.68229 13.0781 6.61719C13.0521 6.53906 13.0065 6.48047 12.9414 6.44141C12.8763 6.38932 12.8047 6.36328 12.7266 6.36328H11.3398L10.8516 4.9375C10.8255 4.85938 10.7799 4.80078 10.7148 4.76172C10.6497 4.70964 10.5781 4.6901 10.5 4.70312C10.4219 4.6901 10.3438 4.70964 10.2656 4.76172C10.2005 4.80078 10.1549 4.85286 10.1289 4.91797L9.66016 6.30469H8.27344C8.18229 6.29167 8.09766 6.30469 8.01953 6.34375C7.94141 6.38281 7.88281 6.44141 7.84375 6.51953C7.80469 6.61068 7.80469 6.70833 7.84375 6.8125C7.88281 6.90365 7.94792 6.96875 8.03906 7.00781L9.17188 7.88672L8.68359 9.39062C8.65755 9.46875 8.65755 9.54688 8.68359 9.625C8.72266 9.70312 8.77474 9.76172 8.83984 9.80078C8.90495 9.85286 8.97656 9.87891 9.05469 9.87891C9.13281 9.87891 9.20443 9.85286 9.26953 9.80078L10.5 8.86328L11.7305 9.80078C11.7565 9.82682 11.7891 9.84635 11.8281 9.85938C11.8672 9.8724 11.9062 9.87891 11.9453 9.87891C11.9844 9.87891 12.0234 9.8724 12.0625 9.85938C12.1016 9.84635 12.1341 9.83333 12.1602 9.82031C12.2253 9.76823 12.2708 9.70312 12.2969 9.625C12.3229 9.54688 12.3229 9.46875 12.2969 9.39062L11.8281 7.90625L12.9609 7.00781ZM17.4531 8.16016V4C17.4531 3.80469 17.3815 3.64193 17.2383 3.51172C17.1081 3.36849 16.9453 3.29688 16.75 3.29688H16.0469V9.05859C16.0469 9.24089 16.0339 9.42969 16.0078 9.625C15.9948 9.80729 15.9688 9.98307 15.9297 10.1523C16.3724 10.0352 16.7305 9.79427 17.0039 9.42969C17.2904 9.05208 17.4401 8.62891 17.4531 8.16016Z",
      fill: "currentColor"
    }
  )
);
const SvgPrize = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Prize_default = SvgPrize;
